console.log('init_teams.js loaded!');

/* css for the specific page */
import "./pages-assets/teams/teams.css";


   

/* scripts for the specific page */
import "./pages-assets/teams/teams.js";
